import { render, staticRenderFns } from "./WaitBudgetApplicationDetail.vue?vue&type=template&id=1edfcd53&"
import script from "./WaitBudgetApplicationDetail.vue?vue&type=script&lang=js&"
export * from "./WaitBudgetApplicationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports